"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reducers = require("./utils/reducers");

var _reducers2 = require("./reducers");

const combinedReducers = (0, _reducers.combineReducers)({
  status: _reducers2.statusReducer,
  listeners: _reducers2.listenersReducer,
  errors: _reducers2.errorsReducer,
  cache: _reducers2.cacheReducer
});
var _default = combinedReducers;
exports.default = _default;